import { CoordsMessages, TranslationCoordsMessages } from "../interfaces";

export const messages: TranslationCoordsMessages = {
  [CoordsMessages.readCoordsSuccess]: "Coordinates returned successfully",
  [CoordsMessages.noCoordFound]: "No coordinates registered",
  [CoordsMessages.readCoordsError]: "Failed to fetch coordinate(s)"
};
